<template>
  <div :class="'md-layout text-center'">
    <div :class="' md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100 login-page'">
      <login-card header-color="danger">
        <h4 slot="title" :class="'login-title'">Risk Quality Review</h4>
        <p slot="description" :class="'description'">
          <md-progress-spinner v-if="isLoading" :class="'md-accent'" :md-diameter="30" :md-stroke="3"
            md-mode="indeterminate">
          </md-progress-spinner>
        </p>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
export default {
  data() {
    return {
      isLoading: false,
    };
  },

  mounted() {
    this.authenticate();
    // this.mockAuthenticate(); //TODO: Descomentar em dev local
  },

  components: {
    LoginCard,
  },

  computed: {
    isAdmin() {
      return this.$store.state.profile === "admin";
    },
  },

  methods: {
    async mockAuthenticate() {
    if (this.isAuthenticating) return; // Prevenir múltiplas chamadas
    this.isAuthenticating = true;

    try {
        const urlParams = new URLSearchParams(window.location.search);

        // Save redirect URL from store if not already saved and if it's a valid redirect
        const redirectFromStore = this.$store.getters["REDIRECTO"];
        if (!sessionStorage.getItem("redirectTo") && redirectFromStore &&
            redirectFromStore !== "/" && redirectFromStore !== "") {
            sessionStorage.setItem("redirectTo", redirectFromStore);
        }

        if (!urlParams.has('code')) {
            if (this.$storage.getSession('ISUSERLOGGED') !== true) {
                const mockCode = '1234';
                // Em vez de atualizar a URL e chamar mockAuthenticate novamente,
                // fazer a autenticação diretamente
                const response = await this.$api.request.post('/mock/authenticate', {
                    code: mockCode
                });
                await this.handleAuthentication(response.data);
                this.redirectUser();
            } else {
                this.redirectUser();
            }
        } else {
            const code = urlParams.get('code');
            urlParams.delete('code');
            window.history.replaceState(null, '', window.location.pathname);

            const response = await this.$api.request.post('/mock/authenticate', { code });
            await this.handleAuthentication(response.data);
            this.redirectUser();
        }
    } catch (error) {
        console.error('Authentication error:', error);
    } finally {
        this.isAuthenticating = false;
    }
},


async authenticate() {
    if (this.isAuthenticating) return;
    this.isAuthenticating = true;
    this.isLoading = true;

    try {
        const urlParams = new URLSearchParams(window.location.search);

        // Save redirect URL from store if not already saved and if it's a valid redirect
        const redirectFromStore = this.$store.getters["REDIRECTO"];
        // console.log('Login authenticate() - redirectFromStore:', redirectFromStore);
        // console.log('Login authenticate() - current sessionStorage redirectTo:', sessionStorage.getItem("redirectTo"));
        // console.log('Login authenticate() - localStorage pendingRedirect:', localStorage.getItem('pendingRedirect'));

        // Se não há redirectTo no sessionStorage, tentar diferentes fontes
        if (!sessionStorage.getItem("redirectTo")) {
            let urlToSave = null;

            // 1. Tentar usar o valor do store
            if (redirectFromStore && redirectFromStore !== "/" && redirectFromStore !== "") {
                urlToSave = redirectFromStore;
            }
            // 2. Se store estiver vazio, tentar localStorage
            else {
                const pendingRedirect = localStorage.getItem('pendingRedirect');
                if (pendingRedirect && pendingRedirect !== "/" && pendingRedirect !== "") {
                    urlToSave = pendingRedirect;
                    // console.log('Login authenticate() - Using pendingRedirect from localStorage:', urlToSave);
                }
            }

            if (urlToSave) {
                // console.log('Login authenticate() - Saving redirectTo:', urlToSave);
                sessionStorage.setItem("redirectTo", urlToSave);
            }
        }

        if (!urlParams.has('code')) {
            if (this.$storage.getSession('ISUSERLOGGED') !== true) {
                // console.log('Requesting auth URL...');
                const response = await this.$api.request.get('/authenticate');
                if (response.data && response.data.url) {
                    // console.log('Redirecting to auth URL...');
                    window.location.href = response.data.url;
                } else {
                    throw new Error('Invalid auth URL response');
                }
            } else {
                this.redirectUser();
            }
        } else {
            // console.log('Processing authentication code...');
            const code = urlParams.get('code');
            urlParams.delete('code');
            window.history.replaceState(null, '', window.location.pathname);

            const response = await this.$api.request.post('/authenticate', { code });
            await this.handleAuthentication(response.data);
            this.redirectUser();
        }
    } catch (error) {
        console.error('Authentication error:', error);
        this.$toast.error('Authentication failed');
    } finally {
        this.isAuthenticating = false;
        this.isLoading = false;
    }
},

    redirectUser() {
      const redirectTo = sessionStorage.getItem("redirectTo");
      // console.log('redirectUser() - redirectTo from sessionStorage:', redirectTo);

      if (redirectTo && redirectTo !== "/" && redirectTo !== "") {
        sessionStorage.removeItem("redirectTo");
        // Limpar também do localStorage
        localStorage.removeItem('pendingRedirect');

        try {
          // Limpar o # se existir
          let cleanPath = redirectTo.startsWith('#') ? redirectTo.substring(1) : redirectTo;

          // Se não começar com /, adicionar
          if (!cleanPath.startsWith('/')) {
            cleanPath = '/' + cleanPath;
          }

          // console.log('redirectUser() - cleanPath:', cleanPath);

          // Separar path e query manualmente
          const [pathPart, queryPart] = cleanPath.split('?');
          const query = {};

          if (queryPart) {
            queryPart.split('&').forEach(param => {
              const [key, value] = param.split('=');
              if (key && value) {
                query[decodeURIComponent(key)] = decodeURIComponent(value);
              }
            });
          }

          // console.log('redirectUser() - pathPart:', pathPart);
          // console.log('redirectUser() - query:', query);
          // console.log('redirectUser() - Redirecting to:', { path: pathPart, query });
          this.$router.push({ path: pathPart, query });
        } catch (error) {
          console.error('Error parsing redirect URL:', error);
          // console.log('redirectUser() - Fallback: trying direct router push with redirectTo:', redirectTo);

          // Fallback: tentar usar o redirectTo diretamente se for um path válido
          if (redirectTo.includes('/reviews/')) {
            // Limpar o # se existir e fazer push direto
            const cleanPath = redirectTo.startsWith('#') ? redirectTo.substring(1) : redirectTo;
            // console.log('redirectUser() - Fallback push:', cleanPath);
            this.$router.push(cleanPath);
          } else {
            this.$router.push({ name: "Dashboard" });
          }
        }
      } else {
        // console.log('redirectUser() - No valid redirect, going to Dashboard');
        sessionStorage.removeItem("redirectTo");
        localStorage.removeItem('pendingRedirect');
        this.$router.push({ name: "Dashboard" });
      }
    },

    async handleAuthentication(data) {
  try {
    // this.$api.setToken(data.token)

    // Atualizar store
    this.$store.commit("ISUSERLOGGED", true);
    this.$store.commit("USERID", data.user.id);
    this.$store.commit("USERNAME", data.user.name);
    // Não armazenar o token
    // this.$store.commit("USERTOKEN", data.token);
    this.$store.commit("PROFILE", data.user.roles[0].slug);

    const current = data.user.roles[0].slug !== "user"
      ? data.user.roles[0].slug
      : "engagement_leader";
    this.$store.commit("CURRENTPROFILE", current);

    // Salvar no storage com criptografia
    await this.$storage.saveSameAsStore();
  } catch (error) {
    console.error('Authentication error:', error);
    this.$toast.error('Error during authentication');
    this.$router.push({ name: 'Login' });
  }
},
  },
};
</script>
